<template>
  <div class="sTitle flex-ac">
    <!-- <img src="@/assets/images/title3.png" alt="" /> -->
    <i><i></i></i>
    <slot />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters([""]),
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {},
  destroyed() {},
};
</script>
<style lang='stylus' scoped>
.sTitle {
  width: 100%;
  line-height: 40px;
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8);
  position: relative;
  height 40px

  >i>i {
    width: 8px;
    height: 8px;
    display: block;
    background: rgb(17, 130, 251);
    position: absolute;
    top: 2px;
    left: 2px;
    border-radius: 50%;
  }

  >i {
    position: relative;
    display: block;
    align-items: center;
    justify-content: center;
    width: 12px;
    height: 12px;
    margin-right: 8px;
    border-radius: 50%;
    background: rgba(17, 130, 251, 0.2);
  }

  span {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translate(0, -50%);
    font-size: 12px;
    cursor pointer
    font-size: 14px;
    font-weight: 400;
    color: #999;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/sTitle.vue